import moment from "./moment"

export default class PaymentCondition {

  constructor(cond, days, value, weeklyPaymentRule, paymentPeriod) {
    this.cond = cond    
    this.value = value    
    this.weeklyPaymentRule = weeklyPaymentRule || "next"
    this.paymentPeriod = paymentPeriod
    this.days = typeof days == "string" ? days.split(",") : [days.toString()]
  }

  generate() {

    let data = []

    if (this.cond == "weekly") {
      data = weeklyData(this.days, this.value, this.weeklyPaymentRule)
    } else if (this.cond == "monthly") {
      data = monthlyData(this.days, this.value, this.paymentPeriod)
    }

    data.forEach((el) => {
      el.dueDate = moment(el.dueDate).format("YYYY-MM-DD")
      el.weekDayLabel = moment(el.dueDate).format("dddd").toLowerCase()
    })

    return data
  }
}

function weeklyData(days, value, rule) {

  let data = []
  let lastDate = null
  let dueDate = null

  for (const day of days) {

    dueDate = getNextWeekDateOf(day, rule, lastDate)

    data.push({
      dueDate,
      value: (value / days.length),      
    })

    lastDate = dueDate
  }
  
  return data
}

function getNextWeekDateOf(day, rule, lastDate) {

  let today = new Date()
  let advancedWeeks = 0
  let weeksToAdvance = 0
  let currentWeek = moment(today).week()
  let date = incrementDayAt(today)

  if (rule == "next") {
    weeksToAdvance = 1
  } else if (rule == "subsequent") {
    weeksToAdvance = 2
  }

  while (date.getDay() != day || advancedWeeks < weeksToAdvance || 
        (lastDate && moment(lastDate).format("YYYYMMDD") > moment(date).format("YYYYMMDD"))) {
    
    date = incrementDayAt(date) 

    if (moment(date).week() != currentWeek) {
      currentWeek = moment(date).week()
      advancedWeeks++
    }
  }

  return date
}

function monthlyData(days, value, paymentPeriod) {

  let data = []
  let lastDate = null
  let dueDate = null

  if (paymentPeriod == "biweekly")
    days = getBiweeklyDayOf(days)

  for (const day of days) {

    dueDate = getNextMonthDateOf(day, lastDate)

    data.push({
      dueDate,
      value: (value / days.length),      
    })

    lastDate = dueDate
  }
  
  return data
}

function getBiweeklyDayOf(days) {

  let today = new Date()
  let monthDay = today.getDate()
  let day1 = days[0]
  let day2 = days.length > 1 ? days[1] : day1

  return monthDay <= 15 ? [day1] : [day2]
}

function getNextMonthDateOf(day, lastDate) {

  let today = new Date()
  let date = incrementDayAt(today)    
  let lastMonthDay = moment.getLastDayOfMonth(today).getDate()

  if (day > lastMonthDay)
    day = lastMonthDay

  while (date.getDate() != day ||
        (lastDate && moment(lastDate).format("YYYYMMDD") > moment(date).format("YYYYMMDD"))) {
    date = incrementDayAt(date)
  }

  return date
}

function incrementDayAt(date) {
  return moment(date).add(1, "days").toDate()
}